
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PatientDocumentsModel } from '../models/PatientDocumentsModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class PatientDocumentsService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public GetPatientDocuments(documenttype:string,PatientCode: string , comCode: string ) {
      let params = new HttpParams();
        params = params.append("DocumentType", documenttype);
        params = params.append("PatientCode", PatientCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<PatientDocumentsModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/PatientDocuments/GetPatientDocuments',options);
    }
    public GetDocumentsSerial(PatientCode: string , comCode: string ) {
      let params = new HttpParams();
        params = params.append("PatientCode", PatientCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<PatientDocumentsModel>(this.urlsconfig.WebAPIURL_Test + 'api/PatientDocuments/GetDocumentsSerial',options);
    }
    convertToFormData(
      jsonObject: Object,
      parentKey: string | null,
      carryFormData: FormData | null
    ): FormData {
      const formData = carryFormData || new FormData();
      let index = 0;
      type ObjectKey = keyof typeof jsonObject;

      for (var keyVal in jsonObject) {
        const key = keyVal as ObjectKey;
        if (jsonObject.hasOwnProperty(keyVal)) {
          if (jsonObject[key] !== null && jsonObject[key] !== undefined) {
            var propName = parentKey || key;
            if (parentKey && this.isObject(jsonObject)) {
              propName =
                parentKey + (!isNaN(Number(key)) ? '[' + key + ']' : '.' + key);
            }
            if (parentKey && this.isArray(jsonObject)) {
              propName = parentKey + '[' + index + ']';
            }
            if (jsonObject[key] instanceof File) {
              formData.append(propName, jsonObject[key] as unknown as File);
            } else if (jsonObject[key] instanceof FileList) {
              for (var j = 0; j < jsonObject[key].length; j++) {
                const fileList = jsonObject[key] as unknown as FileList;
                //TODO
                //formData.append(propName + '[' + j + ']', (jsonObject[key]) ).item(j));
                formData.append(
                  propName /*+ '[' + j + ']'*/,
                  fileList[j] as unknown as File
                );
              }
            } else if (jsonObject[key] instanceof Date) {
              formData.append(
                propName,
                new Date(jsonObject[key].toString()).toUTCString()
              );
            } else if (
              this.isArray(jsonObject[key]) ||
              this.isObject(jsonObject[key])
            ) {
              this.convertToFormData(jsonObject[key], propName, formData);
            } else if (typeof jsonObject[key] === 'boolean') {
              formData.append(propName, +jsonObject[key] ? 'true' : 'false');
            } else {
              formData.append(propName, jsonObject[key].toString());
            }
          }
        }
        index++;
      }
      return formData;
    }
    isArray(val: any) {
      const toString = {}.toString;
      return toString.call(val) === '[object Array]';
    }

    isObject(val: any) {
      return !this.isArray(val) && typeof val === 'object' && !!val;
    }
    public AddPatientDocuments(patientdocuments: PatientDocumentsModel) {
const formData=this.convertToFormData(patientdocuments,null,null);

        return this.http.post<PatientDocumentsModel>(this.urlsconfig.WebAPIURL_Test + 'api/PatientDocuments/AddPatientDocuments', formData);
    }
    public DelPatientDocumentsLine(patientcode: string , doccode :string, compcode :string) {
      let params = new HttpParams();
        params = params.append("patientcode", patientcode);
        params = params.append("doccode", doccode);
        params = params.append("compcode", compcode);
        const options = {
            params: params
        };
        return this.http.get<PatientDocumentsModel>(this.urlsconfig.WebAPIURL_Test + 'api/PatientDocuments/DeletePatientDocumentsLine',options);
    }

}
